/**
 * Challenge card styles – composed from business-logic partials.
 * Use getChallengeCardStyles(theme) with useTheme() for theme-aware cards.
 */

import { StyleSheet, Dimensions } from 'react-native';
import type { Theme } from '../../theme/getTheme';
import { getTheme } from '../../theme/getTheme';
import { getChallengeCardCoreStyles } from './challengeCardCore.styles';
import { getChallengeCardMatchesStyles } from './challengeCardMatches.styles';
import { getChallengeCardHeaderStyles } from './challengeCardHeader.styles';
import { getChallengeCardCreateStyles } from './challengeCardCreate.styles';

/** Breakpoint below which home header countdown uses smaller sizes (phones). */
const NARROW_HEADER_BREAKPOINT = 400;

function buildChallengeCardStyles(theme: Theme, opts?: { expandedScrollMaxHeight?: number }) {
  const windowWidth = Dimensions.get('window').width;
  const narrow = windowWidth < NARROW_HEADER_BREAKPOINT;
  const combined = {
    ...getChallengeCardCoreStyles(theme),
    ...getChallengeCardMatchesStyles(theme),
    ...getChallengeCardHeaderStyles(theme, narrow),
    ...getChallengeCardCreateStyles(theme),
    ...(opts?.expandedScrollMaxHeight != null && {
      expandedScrollContent: { flexGrow: 0, maxHeight: opts.expandedScrollMaxHeight },
    }),
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return StyleSheet.create(combined as any);
}

/** Type for challenge card styles. Use for styles prop. */
export type ChallengeCardStyles = ReturnType<typeof buildChallengeCardStyles>;

/**
 * Theme-aware challenge card styles.
 * Composes core, matches, header, and create partials.
 */
export const getChallengeCardStyles = buildChallengeCardStyles;

/** @deprecated Use getChallengeCardStyles(theme) with useTheme() for dark mode support. */
export const challengeCardStyles = buildChallengeCardStyles(getTheme('light'));
